export const messages = {
  'error.access.login':
    'Login fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.',
  'error.user.password.notSame':
    'Login fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.'
}
